const createCard = (state = {}, action) => {
  switch(action.type){
    case 'ADD_CARD_DATA':
      return action.data;

    case 'CLEAR_CARD_DATA':
      return null;

    default:
      return state;
  }
}

export default createCard